import { Link } from "react-router-dom";
import type { Video } from "@/types";
import { formatCount } from "@/utils/format";

interface VideoCardProps {
  video: Video;
  index?: number;
}

export default function VideoCard({ video, index = 0 }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 一起草视频高清在线观看`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs font-medium tabular-nums">
          {video.duration}
        </span>
        <span className="absolute left-2 top-2 px-2 py-0.5 rounded-md bg-primary-600/90 text-background-50 text-xs font-medium">
          {video.categoryName}
        </span>
        <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-accent-500 text-primary-950 flex items-center justify-center opacity-0 group-hover:opacity-100 scale-90 group-hover:scale-100 transition-all duration-300">
          <i className="ri-play-fill text-2xl" />
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 clamp-1 group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <p className="mt-1 text-xs md:text-sm text-foreground-500 clamp-1">{video.subtitle}</p>
        <div className="mt-2.5 flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-play-circle-line text-sm" />
            </span>
            {formatCount(video.plays)}
          </span>
          <span className="flex items-center gap-1">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-bookmark-line text-sm" />
            </span>
            {formatCount(video.favorites)}
          </span>
          <span className="ml-auto whitespace-nowrap">{video.uploadTime}</span>
        </div>
      </div>
    </Link>
  );
}